/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Auftragsvorlage } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * AuftragsvorlageService - axios parameter creator
 * @export
 */
export const AuftragsvorlageServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Erstellt eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {Auftragsvorlage} [auftragsvorlage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuftragsvorlage: async (auftragsvorlage?: Auftragsvorlage, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftragsvorlagen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auftragsvorlage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Entfernt eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuftragsvorlage: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAuftragsvorlage', 'id', id)
            const localVarPath = `/api/auftragsvorlagen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert true wenn eine Auftragsvorlage mit ein Bestimmten name / mandant id schon existiert, sonst false
         * @summary Auftragsvorlagesuche
         * @param {string} name Search Query
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exists: async (name: string, mandantId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('exists', 'name', name)
            const localVarPath = `/api/auftragsvorlagen/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (mandantId !== undefined) {
                localVarQueryParameter['mandantId'] = mandantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Auftragsvorlage
         * @summary Auftragsvorlage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragsvorlageById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAuftragsvorlageById', 'id', id)
            const localVarPath = `/api/auftragsvorlagen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Auftragsvorlagen anhand der Suchkriterien
         * @summary Auftragsvorlagesuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAuftragsvorlage: async (query?: string, page?: number, searchLimit?: number, mandantId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftragsvorlagen/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchLimit !== undefined) {
                localVarQueryParameter['searchLimit'] = searchLimit;
            }

            if (mandantId !== undefined) {
                localVarQueryParameter['mandantId'] = mandantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualisiert eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {number} id 
         * @param {Auftragsvorlage} [auftragsvorlage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuftragsvorlage: async (id: number, auftragsvorlage?: Auftragsvorlage, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAuftragsvorlage', 'id', id)
            const localVarPath = `/api/auftragsvorlagen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auftragsvorlage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuftragsvorlageService - functional programming interface
 * @export
 */
export const AuftragsvorlageServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuftragsvorlageServiceAxiosParamCreator(configuration)
    return {
        /**
         * Erstellt eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {Auftragsvorlage} [auftragsvorlage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAuftragsvorlage(auftragsvorlage?: Auftragsvorlage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftragsvorlage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAuftragsvorlage(auftragsvorlage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Entfernt eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAuftragsvorlage(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftragsvorlage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAuftragsvorlage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert true wenn eine Auftragsvorlage mit ein Bestimmten name / mandant id schon existiert, sonst false
         * @summary Auftragsvorlagesuche
         * @param {string} name Search Query
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exists(name: string, mandantId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftragsvorlage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exists(name, mandantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Auftragsvorlage
         * @summary Auftragsvorlage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftragsvorlageById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftragsvorlage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftragsvorlageById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Auftragsvorlagen anhand der Suchkriterien
         * @summary Auftragsvorlagesuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAuftragsvorlage(query?: string, page?: number, searchLimit?: number, mandantId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftragsvorlage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAuftragsvorlage(query, page, searchLimit, mandantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aktualisiert eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {number} id 
         * @param {Auftragsvorlage} [auftragsvorlage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAuftragsvorlage(id: number, auftragsvorlage?: Auftragsvorlage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftragsvorlage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAuftragsvorlage(id, auftragsvorlage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuftragsvorlageService - factory interface
 * @export
 */
export const AuftragsvorlageServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuftragsvorlageServiceFp(configuration)
    return {
        /**
         * Erstellt eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {Auftragsvorlage} [auftragsvorlage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuftragsvorlage(auftragsvorlage?: Auftragsvorlage, options?: any): AxiosPromise<Auftragsvorlage> {
            return localVarFp.createAuftragsvorlage(auftragsvorlage, options).then((request) => request(axios, basePath));
        },
        /**
         * Entfernt eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuftragsvorlage(id: number, options?: any): AxiosPromise<Auftragsvorlage> {
            return localVarFp.deleteAuftragsvorlage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert true wenn eine Auftragsvorlage mit ein Bestimmten name / mandant id schon existiert, sonst false
         * @summary Auftragsvorlagesuche
         * @param {string} name Search Query
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exists(name: string, mandantId?: number, options?: any): AxiosPromise<Array<Auftragsvorlage>> {
            return localVarFp.exists(name, mandantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Auftragsvorlage
         * @summary Auftragsvorlage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragsvorlageById(id: number, options?: any): AxiosPromise<Auftragsvorlage> {
            return localVarFp.getAuftragsvorlageById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Auftragsvorlagen anhand der Suchkriterien
         * @summary Auftragsvorlagesuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAuftragsvorlage(query?: string, page?: number, searchLimit?: number, mandantId?: number, options?: any): AxiosPromise<Array<Auftragsvorlage>> {
            return localVarFp.searchAuftragsvorlage(query, page, searchLimit, mandantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualisiert eine bestehende Auftragsvorlage
         * @summary Auftragsvorlagen
         * @param {number} id 
         * @param {Auftragsvorlage} [auftragsvorlage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuftragsvorlage(id: number, auftragsvorlage?: Auftragsvorlage, options?: any): AxiosPromise<Auftragsvorlage> {
            return localVarFp.updateAuftragsvorlage(id, auftragsvorlage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuftragsvorlageService - interface
 * @export
 * @interface AuftragsvorlageService
 */
export interface AuftragsvorlageServiceInterface {
    /**
     * Erstellt eine bestehende Auftragsvorlage
     * @summary Auftragsvorlagen
     * @param {Auftragsvorlage} [auftragsvorlage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageServiceInterface
     */
    createAuftragsvorlage(auftragsvorlage?: Auftragsvorlage, options?: any): AxiosPromise<Auftragsvorlage>;

    /**
     * Entfernt eine bestehende Auftragsvorlage
     * @summary Auftragsvorlagen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageServiceInterface
     */
    deleteAuftragsvorlage(id: number, options?: any): AxiosPromise<Auftragsvorlage>;

    /**
     * Liefert true wenn eine Auftragsvorlage mit ein Bestimmten name / mandant id schon existiert, sonst false
     * @summary Auftragsvorlagesuche
     * @param {string} name Search Query
     * @param {number} [mandantId] Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageServiceInterface
     */
    exists(name: string, mandantId?: number, options?: any): AxiosPromise<Array<Auftragsvorlage>>;

    /**
     * Liefert eine Auftragsvorlage
     * @summary Auftragsvorlage
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageServiceInterface
     */
    getAuftragsvorlageById(id: number, options?: any): AxiosPromise<Auftragsvorlage>;

    /**
     * Liefert eine Liste von Auftragsvorlagen anhand der Suchkriterien
     * @summary Auftragsvorlagesuche
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {number} [mandantId] Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageServiceInterface
     */
    searchAuftragsvorlage(query?: string, page?: number, searchLimit?: number, mandantId?: number, options?: any): AxiosPromise<Array<Auftragsvorlage>>;

    /**
     * Aktualisiert eine bestehende Auftragsvorlage
     * @summary Auftragsvorlagen
     * @param {number} id 
     * @param {Auftragsvorlage} [auftragsvorlage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageServiceInterface
     */
    updateAuftragsvorlage(id: number, auftragsvorlage?: Auftragsvorlage, options?: any): AxiosPromise<Auftragsvorlage>;

}

/**
 * AuftragsvorlageService - object-oriented interface
 * @export
 * @class AuftragsvorlageService
 * @extends {BaseAPI}
 */
export class AuftragsvorlageService extends BaseAPI implements AuftragsvorlageServiceInterface {
    /**
     * Erstellt eine bestehende Auftragsvorlage
     * @summary Auftragsvorlagen
     * @param {Auftragsvorlage} [auftragsvorlage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageService
     */
    public createAuftragsvorlage(auftragsvorlage?: Auftragsvorlage, options?: any) {
        return AuftragsvorlageServiceFp(this.configuration).createAuftragsvorlage(auftragsvorlage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Entfernt eine bestehende Auftragsvorlage
     * @summary Auftragsvorlagen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageService
     */
    public deleteAuftragsvorlage(id: number, options?: any) {
        return AuftragsvorlageServiceFp(this.configuration).deleteAuftragsvorlage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert true wenn eine Auftragsvorlage mit ein Bestimmten name / mandant id schon existiert, sonst false
     * @summary Auftragsvorlagesuche
     * @param {string} name Search Query
     * @param {number} [mandantId] Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageService
     */
    public exists(name: string, mandantId?: number, options?: any) {
        return AuftragsvorlageServiceFp(this.configuration).exists(name, mandantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Auftragsvorlage
     * @summary Auftragsvorlage
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageService
     */
    public getAuftragsvorlageById(id: number, options?: any) {
        return AuftragsvorlageServiceFp(this.configuration).getAuftragsvorlageById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Auftragsvorlagen anhand der Suchkriterien
     * @summary Auftragsvorlagesuche
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {number} [mandantId] Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageService
     */
    public searchAuftragsvorlage(query?: string, page?: number, searchLimit?: number, mandantId?: number, options?: any) {
        return AuftragsvorlageServiceFp(this.configuration).searchAuftragsvorlage(query, page, searchLimit, mandantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualisiert eine bestehende Auftragsvorlage
     * @summary Auftragsvorlagen
     * @param {number} id 
     * @param {Auftragsvorlage} [auftragsvorlage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragsvorlageService
     */
    public updateAuftragsvorlage(id: number, auftragsvorlage?: Auftragsvorlage, options?: any) {
        return AuftragsvorlageServiceFp(this.configuration).updateAuftragsvorlage(id, auftragsvorlage, options).then((request) => request(this.axios, this.basePath));
    }
}
